var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext, useMemo } from "react";
import { DatagridConfigurable, FunctionField, List, TextField, useRecordContext, } from "react-admin";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { ResourceListStyles } from "@/components/styles/ResourceListStyles";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import SelectElection from "@/components/election/SelectElection";
import { COUNTRIES } from "@/lib/countries";
import { FormStyles } from "@/components/styles/FormStyles";
import { ListActions } from "@/components/ListActions";
import { useAliasRenderer } from "@/hooks/useAliasRenderer";
var ListStyle = styled(List)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    button.RaFilterFormInput-hideButton {\n        margin-bottom: 26px !important;\n    }\n"], ["\n    button.RaFilterFormInput-hideButton {\n        margin-bottom: 26px !important;\n    }\n"])));
var Empty = function () {
    var t = useTranslation().t;
    return (_jsx(ResourceListStyles.EmptyBox, { style: { margin: "8px" }, children: _jsx(Typography, { variant: "h4", paragraph: true, children: t("dashboard.ipAddress.emptyState") }) }));
};
export var ListIpAddress = function (_a) {
    var _b;
    var aside = _a.aside;
    var t = useTranslation().t;
    var tenantId = useTenantStore()[0];
    var globalSettings = useContext(SettingsContext).globalSettings;
    var aliasRenderer = useAliasRenderer();
    var record = useRecordContext();
    var electionEventId = (_b = record === null || record === void 0 ? void 0 : record.election_event_id) !== null && _b !== void 0 ? _b : record === null || record === void 0 ? void 0 : record.id;
    var electionId = (record === null || record === void 0 ? void 0 : record.election_event_id) ? record === null || record === void 0 ? void 0 : record.id : undefined;
    var Filters = useMemo(function () { return [
        _jsx(FormStyles.TextInput, { source: "ip", label: t("dashboard.ipAddress.ip") }, "ip"),
        _jsx(FormStyles.AutocompleteInput, { source: "country", label: t("dashboard.ipAddress.country"), choices: COUNTRIES, optionValue: "code", fullWidth: true }, "country"),
        _jsx(SelectElection, { source: "election_id", label: t("dashboard.ipAddress.ElectionName"), tenantId: tenantId, electionEventId: electionEventId }, "election"),
    ]; }, []);
    var filters = function () {
        var filters = {
            tenant_id: tenantId,
        };
        if (electionEventId) {
            filters["election_event_id"] = electionEventId;
        }
        if (electionId) {
            filters["election_id"] = electionId;
        }
        return filters;
    };
    if (!electionEventId) {
        return null;
    }
    return (_jsxs(Box, { className: "print-hidden", children: [_jsx(Typography, { variant: "h4", children: t("dashboard.ipAddress.title") }), _jsx(ListStyle, { resource: "ip_address", queryOptions: {
                    refetchInterval: globalSettings.QUERY_POLL_INTERVAL_MS,
                }, empty: _jsx(Empty, {}), filter: filters(), storeKey: false, aside: aside, filters: Filters, actions: _jsx(ListActions, { withImport: false, defaultExport: true }), children: _jsxs(DatagridConfigurable, { omit: ["voters_id"], children: [_jsx(FunctionField, { source: "ip", sortable: false, label: t("dashboard.ipAddress.ip"), render: function (record) { return (record.ip ? record.ip : "-"); } }), _jsx(FunctionField, { source: "country", sortable: false, label: t("dashboard.ipAddress.country"), render: function (record) {
                                return record.country ? record.country : "-";
                            } }), _jsx(TextField, { source: "vote_count", sortable: false, label: t("dashboard.ipAddress.VoteCount") }), _jsx(FunctionField, { source: "election_presentation", sortable: false, label: t("dashboard.ipAddress.ElectionName"), render: function (record) {
                                return aliasRenderer(record.election_presentation);
                            } }), _jsx(TextField, { source: "voters_id", sortable: false, label: t("dashboard.ipAddress.VotersId") })] }) })] }));
};
var templateObject_1;
